export default __webpack_public_path__ + "static/media/PROCESSMETHOD_CNC_MILLING.5e4342d9.png";